import * as React from 'react'

function SvgPa(props) {
	return (
		<svg viewBox="0 0 36 24" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M0 0h36v24H0z" />
			<g fill="#005293">
				<g id="pa_svg__c" transform="translate(9 6)">
					<g id="pa_svg__b">
						<path id="pa_svg__a" d="M0-3v3h1.5z" transform="rotate(18 0 -3)" />
						<use xlinkHref="#pa_svg__a" transform="scale(-1 1)" />
					</g>
					<use xlinkHref="#pa_svg__b" transform="rotate(72)" />
					<use xlinkHref="#pa_svg__b" transform="rotate(144)" />
					<use xlinkHref="#pa_svg__b" transform="rotate(216)" />
					<use xlinkHref="#pa_svg__b" transform="rotate(288)" />
				</g>
				<path d="M0 12h18v12H0z" />
			</g>
			<g fill="#d21034">
				<path d="M18 0h18v12H18z" />
				<use xlinkHref="#pa_svg__c" x={18} y={12} />
			</g>
		</svg>
	)
}

export default SvgPa
